import http from '@/common/utils/http-common';

class LoginService {
  getCurrentAuthenticatedUser() {
    return http.get(`/auth`);
  }

  logoutCurrentAuthenticateUser() {
    return http.get(`/authout`);
  }
}

export default new LoginService();
